/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SharedReportLoginInput = {
    sharedId: string;
    password: string;
    clientMutationId?: string | null | undefined;
};
export type sharedReportLoginMutationVariables = {
    input: SharedReportLoginInput;
};
export type sharedReportLoginMutationResponse = {
    readonly sharedReportLogin: {
        readonly viewer: {
            readonly id: string;
        } | null;
        readonly success: boolean | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type sharedReportLoginMutation = {
    readonly response: sharedReportLoginMutationResponse;
    readonly variables: sharedReportLoginMutationVariables;
};



/*
mutation sharedReportLoginMutation(
  $input: SharedReportLoginInput!
) {
  sharedReportLogin(input: $input) {
    viewer {
      id
    }
    success
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SharedReportLoginInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharedReportLoginPayload",
    "kind": "LinkedField",
    "name": "sharedReportLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedReportLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedReportLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sharedReportLoginMutation",
    "operationKind": "mutation",
    "text": "mutation sharedReportLoginMutation(\n  $input: SharedReportLoginInput!\n) {\n  sharedReportLogin(input: $input) {\n    viewer {\n      id\n    }\n    success\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '85245d82e62d396c1673e636b532e30a';
export default node;
